//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getReviewEmailSentService } from "./reviewEmailSentApi";

export default function useReviewEmailSentList() {
  const params = useParams<"booking_id">();
  const scope = { bookings: params.booking_id };
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "review-email-sents/"
      : ""
  }`;
  const service = getReviewEmailSentService({ bookings: params.booking_id });

  return { ...service, params, scope, editUrl };
}
